import { create } from 'zustand';

type State = {
    isVisible: boolean;
    filterType: string | null;
};

type Action = {
    setIsVisibleServices: (isVisible: boolean, filterType?: string) => void;
};

export const useModalServicesStore = create<State & Action>(set => ({
    isVisible: false,
    filterType: null,

    setIsVisibleServices: (isVisible, filterType) => {
        set(() => ({
            isVisible,
            filterType: filterType || null,
        }));
    },
}));
